(() => {
  if (window.replicaCartPageController) return;
  window.replicaCartPageController = true;
  let busy = false;
  const stop = event => { event.preventDefault(); event.stopImmediatePropagation(); };
  const update = async (form, input, quantity) => {
    if (busy) return;
    if (!Number.isInteger(quantity) || quantity < 0) return;
    busy = true;
    form.classList.add('is-loading');
    let error = form.querySelector('[data-cart-update-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.cartUpdateError = '';
      error.setAttribute('role', 'alert');
      form.append(error);
    }
    error.textContent = '';
    try {
      const url = new URL(form.action);
      url.pathname = url.pathname.replace(/\/$/, '') + '/change.js';
      const response = await fetch(url, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: input.dataset.lineKey, quantity })
      });
      const cart = await response.json();
      if (!response.ok || cart.status >= 400) throw new Error(cart.description || 'Unable to update quantity.');
      // Reload the current preview URL, never the checkout endpoint.
      location.reload();
    } catch (failure) {
      input.value = input.defaultValue;
      error.textContent = failure.message || 'Unable to update quantity. Please try again.';
      busy = false;
      form.classList.remove('is-loading');
    }
  };
  const prepareCheckout = (event, form) => {
    if (busy || document.querySelector('.replica-cart-controller[aria-busy="true"]') || !form) {
      stop(event);
      return;
    }
    if (form.dataset.cartStale === 'true') form.querySelectorAll('[name="updates[]"]').forEach(input => { input.disabled = true; });
    // Preserve the browser submit event so payment apps can take over checkout.
  };
  window.addEventListener('click', event => {
    const button = event.target.closest?.('.replica-cart__form button');
    if (!button) return;
    const form = button.closest('form');
    if (button.matches('.replica-cart__checkout')) { prepareCheckout(event, form); return; }
    if (!button.dataset.quantityChange) return;
    stop(event);
    const input = button.closest('[data-cart-line]').querySelector('[data-quantity-input]');
    const value = Number(input.value), step = Number(input.step) || 1, min = Number(input.min) || 1;
    const quantity = button.dataset.quantityChange === 'plus' ? value + step : value <= min ? 0 : Math.max(min, value - step);
    if (input.max && quantity > Number(input.max)) return;
    update(form, input, quantity);
  }, true);
  window.addEventListener('change', event => {
    if (!event.target.matches('.replica-cart__form [data-quantity-input]')) return;
    stop(event);
    update(event.target.closest('form'), event.target, Number(event.target.value));
  }, true);
  window.addEventListener('keydown', event => {
    if (event.key !== 'Enter' || !event.target.matches('.replica-cart__form [data-quantity-input]')) return;
    stop(event);
    update(event.target.closest('form'), event.target, Number(event.target.value));
  }, true);
  window.addEventListener('submit', event => {
    if (!event.target.matches('.replica-cart__form')) return;
    if (event.submitter && !event.submitter.matches('[name="checkout"]')) { stop(event); return; }
    prepareCheckout(event, event.target);
  }, true);
})();
